"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      form: {},
      code_sn: this.$route.query.code_sn || ''
    };
  },
  mounted: function mounted() {
    if (this.code_sn && window.codeInfo) {
      this.form = window.codeInfo;
    }
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;
      var params = JSON.parse(JSON.stringify(this.form)),
        url = 'QRcode/edit_qrcode';
      params.code_agent_id = params.agent_id;
      this.$post(url, params).then(function (res) {
        _this.$message({
          message: '提交成功',
          type: 'success'
        });
        history.back();
      });
    }
  }
};